export type BudgetMonthlyItemData = {
  id: string;
  analyticalItemId: string;
  analyticalItemCode: string;
  analyticalItemName: string;
  applyStartDate: Date | null;
  applyEndDate: Date | null;
  advertisingMediaMstCode: string;
  analyticalClassificationType: string;
  expensesClassification: number;
  budgetType: number;
  budgetDiscributionType: number;
  budgetSalesRatio: number;
  salesRatioRounding: number;
  sumFlag: number;
  orgCode: string;
  monthAry: number[];
  monthTotal: number;
  idAndCode: string;
};

/**
 * APIのデータ型
 */
export interface StoreManagement {
  targetYear: string;
  yearLtMonth: Array<string> | null;
  yearLtSales: Array<BudgetMonthlyItemData> | null;
  yearLtCost: Array<BudgetMonthlyItemData> | null;
  yearLtLabor: Array<BudgetMonthlyItemData> | null;
  yearLtAdvertising: Array<BudgetMonthlyItemData> | null;
  yearLtRent: Array<BudgetMonthlyItemData> | null;
  yearLtExpenses: Array<BudgetMonthlyItemData> | null;
  yearLtOther: Array<BudgetMonthlyItemData> | null;
  yearLtCustomPrice: BudgetMonthlyItemData | null;
}

export default class StoreManagementDomain {
  constructor(private rawData: StoreManagement) {
    // do nothing
  }

  static generateInitial(): StoreManagementDomain {
    return new StoreManagementDomain({
      targetYear: '',
      yearLtMonth: [],
      yearLtSales: [],
      yearLtCost: [],
      yearLtLabor: [],
      yearLtAdvertising: [],
      yearLtRent: [],
      yearLtExpenses: [],
      yearLtOther: [],
      yearLtCustomPrice: null,
    });
  }

  getRawData(): StoreManagement {
    return this.rawData;
  }

  get targetYear(): String {
    return this.rawData.targetYear;
  }

  get yearLtMonth(): Array<string> {
    return this.rawData.yearLtMonth ?? [];
  }

  set yearLtMonth(yearLtMonth: Array<string>) {
    this.rawData.yearLtMonth = yearLtMonth;
  }

  get yearLtSales(): Array<BudgetMonthlyItemData> | null {
    return this.rawData.yearLtSales;
  }

  set yearLtSales(yearLtSales: Array<BudgetMonthlyItemData> | null) {
    this.rawData.yearLtSales = yearLtSales;
  }

  get yearLtCost(): Array<BudgetMonthlyItemData> | null {
    return this.rawData.yearLtCost;
  }

  set yearLtCost(yearLtCost: Array<BudgetMonthlyItemData> | null) {
    this.rawData.yearLtCost = yearLtCost;
  }

  get yearLtLabor(): Array<BudgetMonthlyItemData> | null {
    return this.rawData.yearLtLabor;
  }

  set yearLtLabor(yearLtLabor: Array<BudgetMonthlyItemData> | null) {
    this.rawData.yearLtLabor = yearLtLabor;
  }

  get yearLtAdvertising(): Array<BudgetMonthlyItemData> | null {
    return this.rawData.yearLtAdvertising;
  }

  set yearLtAdvertising(yearLtAdvertising: Array<BudgetMonthlyItemData> | null) {
    this.rawData.yearLtAdvertising = yearLtAdvertising;
  }

  get yearLtRent(): Array<BudgetMonthlyItemData> | null {
    return this.rawData.yearLtRent;
  }

  set yearLtRent(yearLtRent: Array<BudgetMonthlyItemData> | null) {
    this.rawData.yearLtRent = yearLtRent;
  }

  get yearLtExpenses(): Array<BudgetMonthlyItemData> | null {
    return this.rawData.yearLtExpenses;
  }

  set yearLtExpenses(yearLtExpenses: Array<BudgetMonthlyItemData> | null) {
    this.rawData.yearLtExpenses = yearLtExpenses;
  }

  get yearLtOther(): Array<BudgetMonthlyItemData> | null {
    return this.rawData.yearLtOther;
  }

  set yearLtOther(yearLtOther: Array<BudgetMonthlyItemData> | null) {
    this.rawData.yearLtOther = yearLtOther;
  }

  get yearLtCustomPrice(): BudgetMonthlyItemData | null {
    return this.rawData.yearLtCustomPrice;
  }

  set yearLtCustomPrice(yearLtCustomPrice: BudgetMonthlyItemData | null) {
    this.rawData.yearLtCustomPrice = yearLtCustomPrice;
  }
}
